<template>
  <div class="poster-box">
    <div class="picture-area">
      <WebpImage
        :imageInfo="{
          imageUrl: posterImage,
          width: 1240,
          height: 698,
          className: 'poster-thumb',
        }"
      />
    </div>
  </div>
</template>

<script>
  import WebpImage from '@/components/image/WebpImage'
  export default {
    name: 'PosterHorizontal',
    components: { WebpImage },
    props: {
      posterImage: {
        type: String,
        default: null,
      },
      posterAltText: {
        type: String,
        default: null,
      },
    },
  }
</script>
<style lang="scss">
  @import '../../assets/scss/import/mixin';
  .poster-box {
    @include Position(absolute, $right: 0, $left: auto, $top: 0);
    min-width: 1240px;
    height: 698px;
    z-index: 10;
    .poster-thumb {
      width: 1240px;
      height: 698px;
    }
    &::before {
      @include Position(absolute, $right: 0, $top: 0);
      @include BackgroundImage(
        $path: '../../assets/images/vod/detail_gra_bg.png',
        $size: 1240px auto,
        $repeat: no-repeat
      );
      width: 1240px;
      height: 698px;
      z-index: 10;
      content: '';
    }
    &::after {
      @include Position(absolute, $left: 0, $right: 0, $top: 0);
      height: 1px;
      background-color: #1b1b1b;
      content: '';
    }
  }
</style>
